import { useState } from 'react';
import { Dropdown } from 'react-bootstrap';
import type { PriceInfo } from '../models/types';

interface PriceDisplayProps {
  readonly prices: PriceInfo[] | undefined;
  readonly className?: string;
}

export const PriceDisplay = ({ prices, className = '' }: PriceDisplayProps) => {
  const [selectedCurrency, setSelectedCurrency] = useState<string>('');

  if (!prices || prices.length === 0) {
    return null;
  }

  if (prices.length === 1) {
    const price = prices[0];
    if (!price) {
      return null;
    }

    return (
      <div className={`d-flex gap-2 align-items-center ${className}`} onClick={(e) => e.stopPropagation()}>
        {price.salesPrice && (
          <span className="fw-bold text-primary">
            {price.currency} {price.salesPrice.toFixed(2)}
          </span>
        )}
        {price.originalPrice && price.salesPrice && price.originalPrice > price.salesPrice && (
          <span className="text-muted text-decoration-line-through small">
            {price.currency} {price.originalPrice.toFixed(2)}
          </span>
        )}
      </div>
    );
  }

  const currentPrice = selectedCurrency ? prices.find((p) => p.currency === selectedCurrency) || prices[0] : prices[0];

  if (!currentPrice) {
    return null;
  }

  return (
    <div className={`d-flex gap-2 align-items-center ${className}`} onClick={(e) => e.stopPropagation()}>
      <Dropdown>
        <Dropdown.Toggle variant="outline-secondary" size="sm">
          {currentPrice.currency}
        </Dropdown.Toggle>
        <Dropdown.Menu>
          {prices.map((price, index) => (
            <Dropdown.Item
              key={`${price.currency}-${index}`}
              onClick={() => setSelectedCurrency(price.currency)}
              active={selectedCurrency === price.currency || (!selectedCurrency && index === 0)}
            >
              {price.currency}
            </Dropdown.Item>
          ))}
        </Dropdown.Menu>
      </Dropdown>

      <div className="d-flex gap-2 align-items-center">
        {currentPrice.salesPrice && <span className="fw-bold text-primary">{currentPrice.salesPrice.toFixed(2)}</span>}
        {currentPrice.originalPrice &&
          currentPrice.salesPrice &&
          currentPrice.originalPrice > currentPrice.salesPrice && (
            <span className="text-muted text-decoration-line-through small">
              {currentPrice.originalPrice.toFixed(2)}
            </span>
          )}
      </div>
    </div>
  );
};
